<template>
  <el-dialog
      :title="title"
      ref="downLoadFileDialog"
      :visible.sync="visible"
      :modal="true"
      :modal-append-to-body="false"
      :append-to-body="true"
      :close-on-click-modal="false"
      width="400px"
      :before-close="handleClose">
    <div v-for="item in fileUrlList" class="mt10">
      <span style="color: #3487E2;">{{ item.fileName }}</span>
      <span @click="openFile(item.fileUrl)" class="poi g47"><i class="el-icon-download poi"
                                                               style="float: right"></i></span><br>
    </div>
    <div slot="footer">
      <el-button type="primary" @click="submitForm()">打包下载</el-button>
      <el-button @click="handleClose();">取 消</el-button>
    </div>
  </el-dialog>

</template>

<script>
import {modelMixin, visibleMixin} from "@/components/mixins";
import LzUpload from "@/components/upload/index";

export default {
  name: 'downLoadFile',
  components: {LzUpload},
  mixins: [visibleMixin, modelMixin],
  props: {
    title: {
      type: String,
      default: "",
    },
  },
  computed: {},
  data() {
    return {
      fileUrlList: [
        // {
        //   fileName: "测试01",
        //   fileUrl: "https://static-store-h.oss-cn-hangzhou.aliyuncs.com/64924f8a8a52dc83f73eeb5b.xlsx"
        // },
        // {fileName: "测试02", fileUrl: "https://static-store-h.oss-cn-hangzhou.aliyuncs.com/64924f798a52dc83f73eeb59.csv"},
        // {
        //   fileName: "测试03",
        //   fileUrl: "https://static-store-h.oss-cn-hangzhou.aliyuncs.com/64924d678a52dc83f73eeb55.xlsx"
        // },
      ],
    };
  },
  mounted() {

  },
  methods: {
    //查询
    selectByFileId(id) {
      let paramObj = {}
      paramObj.groupId = id
      this.axios({
        url: "/file/query",
        data: paramObj,
        method: "post"
      }).then(r => {
        if (r.success && r.module) {
          this.fileUrlList = r.module
        }
      })
    },
    openFile(url) {
      window.location.href = url;
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
          .then(_ => {
            this.close();
          })
          .catch(_ => {
          });
    },
    submitForm() {
      if (this.fileUrlList && this.fileUrlList.length > 0) {
        let fileUrl = []
        let fileName = []
        this.fileUrlList.forEach(x => fileUrl.push(x.fileUrl));
        this.fileUrlList.forEach(x => fileName.push(x.fileName));
        let param = {
          fileUrl: JSON.stringify(fileUrl),
          fileName: JSON.stringify(fileName),
          fileList: this.fileUrlList,
        }
        this.axios({
          url: '/file/downloadZip',
          method: 'post',
          data: param,
          transformRequest: [data => JSON.stringify(data)],
          headers: {"Content-Type": "application/json; charset=UTF-8"},
        }).then(r => {
          if (r.success && r.module) {
            window.location.href = r.module
            this.$msgbox({
              type: 'success',
              title: '',
              message: '下载成功',
              center: true,
            });
          } else {
            this.$msgbox({
              type: 'error',
              title: '',
              message: '修改失败  ' + (r.errMsg ? r.errMsg : ''),
              center: true,
              confirmButtonText: '返回下载'
            });
          }
        })
      }
    },
  }
};
</script>

<style lang="less">
.ee .el-input__inner {
  height: 32px;
  width: 400px;
}

.tableCss {
  tr {
    td {
      .el-form-item {
        margin-bottom: 0px !important;
        margin-right: 0px !important;
      }

      .el-form-item__content {
        margin-left: 0px !important;
      }

      border-bottom: 1px solid #ebeef5;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/upload/downLoadFile.vue